import React, { useState } from 'react'

import Button from '../Button'
import Dialog from '../Dialog'
import Icon from '../Icon'
import { LocationMap } from '../LocationMap'
import TransitionMantineTooltip from '../TransitionMantineTooltip'

type TLocation = {
  lat?: string
  lon?: string
  button?: boolean
  icon?: string
  label?: string
  children?: React.ReactElement
  title?: string | React.ReactElement
}
const Location = (props: TLocation): React.ReactElement => {
  const { lat, lon, button, icon, label, children, title } = props
  const [isOpen, setIsOpen] = useState(false)

  const open = (): void => setIsOpen(true)

  const close = (): void => setIsOpen(false)

  let trigger = (
    <TransitionMantineTooltip
      tooltip={i18n.t(`show_position_map`, `Position auf Karte anzeigen`)}
    >
      <code
        style={{ textDecoration: 'underline', cursor: 'pointer' }}
        onClick={open}
      >
        <i className="fas fa-location-arrow" />{' '}
        {i18n.t(`show_on_map`, `Auf Karte anzeigen`)}
      </code>
    </TransitionMantineTooltip>
  )

  if (button) {
    trigger = (
      <Button
        small
        icon="fas fa-location-arrow"
        tooltip="Position auf Karte anzeigen"
        onClick={open}
      />
    )
  }

  if (icon) {
    trigger = (
      <div className="d-flex">
        <Icon
          icon="fas fa-location-arrow"
          tooltip="Auf Karte anzeigen"
          onClick={open}
        />
        {label && (
          <div className="ml-1">
            {i18n.t(`show_on_map`, `Auf Karte anzeigen`)}
          </div>
        )}
      </div>
    )
  }

  return (
    <React.Fragment>
      {isOpen && (
        <Dialog
          title={
            <div>
              {title || (
                <div>
                  {i18n.t(`show_position`, `Position anzeigen`)}{' '}
                  <code>
                    ({lat}, {lon})
                  </code>
                </div>
              )}
            </div>
          }
          show
          fullwidth
          onClose={close}
          closeButton={i18n.t(`btn_close`, `Schliessen`)}
        >
          <LocationMap
            value={!lon || !lat ? null : [lon, lat]}
            popover={children}
            showCoordinates
          />
        </Dialog>
      )}
      <div>{trigger}</div>
    </React.Fragment>
  )
}

export default Location
